/**
 * Date-only helpers for booking event dates (YYYY-MM-DD from API).
 * Avoid `new Date("2026-06-21")` — that is UTC midnight and can show the previous
 * calendar day in timezones west of UTC (e.g. 21 Jun → 20 Jun in the US).
 */

export const parseDateOnly = (dateStr) => {
  if (!dateStr) return null;
  const s = String(dateStr).split('T')[0];
  const parts = s.split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;
  const [y, m, d] = parts;
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateOnly = (dateStr, options = {}) => {
  const date = parseDateOnly(dateStr);
  if (!date) return 'Date TBD';
  return date.toLocaleDateString('en-GB', options);
};
